import Vue from 'vue'
import Router from 'vue-router'
import App from '@/App'
import Main from '@/Main.vue'
import AnalyzeInfo from '@/components/AnalyzeInfo'
import ShareReport from '@/components/ShareReport'


Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: App,
      children: [
        {
          path: '/main/:testId/:grade',
          name: 'main',
          props: true,
          component: Main
        },
        {
          path: '/analyze/:testId/:grade/:format',
          name: 'analyze',
          props: true,
          component: AnalyzeInfo
        },
        {
          path: '/shareReport/:testId/:grade',
          name: 'shareReport',
          props: true,
          component: ShareReport
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js